export interface DatasetLocalizations {
    addSubject?: string;
    copySubject?: string;
    subjectList?: string;
    emptyList?: string;
    cardinalityReached?: string;
    deleteSubject?: string;
    deleteSubjectConfirm?: string;
}
